import { Live360DetectorListener } from './Live360DetectorListener';
import { Action, Player, StreamTimelineEvent } from '@quickplay/player-interface';

export class Live360DetectorListenerImpl implements Live360DetectorListener {
  constructor(private readonly player: Player) {
    // no-op
  }

  onStateChange(state: boolean): void {
    this.player.send(
      state ? StreamTimelineEvent.LIVE_360_AVAILABLE : StreamTimelineEvent.LIVE_360_UNAVAILABLE,
      Action.NONE,
    );
  }
}
